import { createFeatureSelector, createSelector, type MemoizedSelector } from '@ngrx/store';

import { type HttpRequestStatus } from '@blaze-shared/shared-util';
import { type StyleSheet } from '@blaze-shared/theming-domain';

import { type State, STYLES_FEATURE_KEY } from './styles.reducer';

const httpFinishedStates: HttpRequestStatus[] = ['success', 'failure'];

export const getStylesState = createFeatureSelector<State>(STYLES_FEATURE_KEY);

export const loadStylesFinished = createSelector(getStylesState, (state) =>
  httpFinishedStates.includes(state.load.status),
);

export const createStylePending = createSelector(
  getStylesState,
  (state) => state.create.status === 'pending',
);

export const createStyleFinished = createSelector(getStylesState, (state) =>
  httpFinishedStates.includes(state.create.status),
);

export const updateStylePending = createSelector(
  getStylesState,
  (state) => state.update.status === 'pending',
);

export const updateStyleFinished = createSelector(getStylesState, (state) =>
  httpFinishedStates.includes(state.update.status),
);

export const upsertStylePending = createSelector(
  createStylePending,
  updateStylePending,
  (creating, updating) => creating || updating,
);

export const upsertStyleFinished = createSelector(
  createStyleFinished,
  updateStyleFinished,
  (createFinished, updateFinished) => createFinished || updateFinished,
);

export const selectStyleSheetsEntityState = createSelector(getStylesState, (state) => state.sheets);

export const selectStyleSheetsEntities = createSelector(
  selectStyleSheetsEntityState,
  (state) => state.entities,
);

export const selectStyleSheetById = (
  styleSheetId: string,
): MemoizedSelector<object, StyleSheet | undefined> =>
  createSelector(selectStyleSheetsEntityState, (state) => state.entities[styleSheetId]);

export const selectCurrentStylesProjectId = createSelector(
  getStylesState,
  (state) => state.projectId,
);
